import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';
import { defineMessages, useIntl } from 'react-intl';

import { NavigationAwareBackArrow } from 'components/navigation/back-arrow';
import { useRequestMyInfoMutation } from 'generated/rbi-graphql';
import useAuth from 'hooks/auth/use-auth';
import AuthRequired from 'pages/authentication/auth-required';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import AccountRequestInfoView from './account-request-info.view';
import { IAccountRequestInfoViewProps } from './types';
import { useFeatureAccountRequestInfoPage } from './use-feature-account-request-info-page';

const messages = defineMessages({
  requestMyInfo: {
    id: 'requestMyInfo',
    defaultMessage: 'Request my info',
    description: 'Header text for requesting users info'
  }
});

export const AccountRequestInfo: FC = () => {
  const { formatMessage } = useIntl();
  const {
    featureAccountRequestInfoPageLoading,
    featureAccountRequestInfoPage
  } = useFeatureAccountRequestInfoPage();

  const { user } = useAuth();
  const mParticle = useMParticleContext();
  const email = user?.details?.email ?? '';

  const [requestMyInfo, requestMyInfoResult] = useRequestMyInfoMutation();

  const handleConfirmClick = async () => {
    mParticle.logEvent(CustomEventNames.BUTTON_CLICK_EMAIL_PROFILE_INFO, EventTypes.UserContent, {
      Status: 'Success'
    });
    await requestMyInfo();
  };

  const accountRequestInfoViewProps: IAccountRequestInfoViewProps = {
    headerText: featureAccountRequestInfoPage?.headerText?.locale,
    content: featureAccountRequestInfoPage?.content?.locale,
    confirmButtonText: featureAccountRequestInfoPage?.confirmButtonText?.locale,
    errorText: featureAccountRequestInfoPage?.errorText?.locale,
    email,
    onConfirm: handleConfirmClick,
    requestMyInfoResult
  };

  return (
    <>
      <Helmet title={formatMessage(messages.requestMyInfo)} />
      <AuthRequired>
        <NavigationAwareBackArrow color={Styles.color.headerContrast} />
        {!featureAccountRequestInfoPageLoading && (
          <AccountRequestInfoView {...accountRequestInfoViewProps} />
        )}
      </AuthRequired>
    </>
  );
};
